import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MyTasksPage } from '@/pages/my-tasks/MyTasksPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

const myTasksSearchSchema = dataTableSearchSchema({
  assignmentId: z.string().optional(),
  surveyId: z.string().optional()
});

export const Route = createFileRoute('/$slug/my-tasks/')({
  component: MyTasksPage,
  validateSearch: myTasksSearchSchema
});
